module.exports = __webpack_public_path__ + "img/pixa-footer-logo.3eb04fd.svg";